<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container" id="desktop">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.6em; font-weight:bold">
      Key Contacts
    </div>
  </div>
  <div class="table-responsive mt-4">
    <table class="table table-bordered image-table">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/HeadshotVillegasLKS.jpg" alt="">
            Carol C. Villegas<br />
            Labaton Keller Sucharow LLP<br />

          </td>
          <td style="vertical-align:middle; width:75%">
            Carol C. Villegas is a Partner in the New York office of Labaton Keller Sucharow LLP and Co-Chair of the Firm’s Consumer Protection and Data Privacy Litigation Practice.
            She is ranked as one of the “top Litigators” in the country by <i>Chambers & Partners USA, The Legal 500, Law360,</i> and <i>National Law Journal,</i> among others, and has been named
            “Plaintiff Litigator of the Year 2026” by <i>Benchmark Litigation.</i>
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/HeadshotChristianLevisLowey.jpg" alt="">
            Christian Levis<br />
            Lowey Dannenberg, PC<br />
          </td>
          <td style="vertical-align:middle; width:75%">
            Christian Levis is a Partner in the New York office of Lowey Dannenberg and Head of the Firm’s Data Breach and Privacy Practice. An award-winning litigator, Mr. Levis is recognized
            as one of the top 500 cyber lawyers and plaintiffs’ lawyers in the world, and a two-time honoree by the American Antitrust Institute for outstanding achievement in private
            enforcement.
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/HeadshotDianaZinserSpector.jpg" alt="">
            Diana J. Zinser<br />
            Spector Caldes & Corrigan PC<br />
          </td>
          <td style="vertical-align:middle; width:75%">
            Diana J. Zinser is a Partner in the Philadelphia office of Spector Caldes & Corrigan where she focuses her practice on consumer protection and data privacy litigation.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container" id="mobile">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.0em; font-weight:bold">
      Key Contacts
    </div>
  </div>
  <div class="table-responsive mt-4">
    <table class="table table-bordered image-table">
      <tbody>
        <tr>
          <td style="font-weight: bold; vertical-align: middle; width: 40%; font-size: .8em">
            <img class="brand__logo" src="../../../assets/images/HeadshotVillegasLKS.jpg" alt="">
            Carol C. Villegas<br />
            Labaton Keller Sucharow LLP<br />

          </td>
          <td style="vertical-align: middle; width: 60%; font-size: .8em">
            Carol C. Villegas is a Partner in the New York office of Labaton Keller Sucharow LLP and Co-Chair of the Firm’s Consumer Protection and Data Privacy Litigation Practice.
            She is ranked as one of the “top Litigators” in the country by <i>Chambers & Partners USA, The Legal 500, Law360,</i> and <i>National Law Journal,</i> among others, and has been named
            “Plaintiff Litigator of the Year 2026” by <i>Benchmark Litigation.</i>
          </td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: middle; width: 25%; font-size: .8em">
            <img class="brand__logo" src="../../../assets/images/HeadshotChristianLevisLowey.jpg" alt="">
            Christian Levis<br />
            Lowey Dannenberg, PC<br />
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            Christian Levis is a Partner in the New York office of Lowey Dannenberg and Head of the Firm’s Data Breach and Privacy Practice. An award-winning litigator, Mr. Levis is recognized
            as one of the top 500 cyber lawyers and plaintiffs’ lawyers in the world, and a two-time honoree by the American Antitrust Institute for outstanding achievement in private
            enforcement.
          </td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: middle; width: 25%; font-size: .8em">
            <img class="brand__logo" src="../../../assets/images/HeadshotDianaZinserSpector.jpg" alt="">
            Diana J. Zinser<br />
            Spector Caldes & Corrigan PC<br />
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            Diana J. Zinser is a Partner in the Philadelphia office of Spector Caldes & Corrigan where she focuses her practice on consumer protection and data privacy litigation.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<br />



